import { Controller } from "@hotwired/stimulus"

// A section of a side column (a project's details, a flow's details) that folds with the app's chevron and shows only a few rows until
// "Show more". Each starts as the server renders it; the reader's own choice to fold a section is remembered in this browser, per
// section (not per project): "I never want Connectors open" is a preference about the column.
const STORE = "emailpa-side-sections"

export default class extends Controller {
    static targets = ["toggle", "body", "row", "more"]
    // `open` draws a section open whatever was remembered, without forgetting it: the handbook's contents always show the part that
    // holds the page being read.
    static values = { key: String, collapsed: Boolean, limit: Number, open: Boolean }

    connect() {
        const saved = this.saved()[this.keyValue]
        this.collapsed = this.openValue ? false : (typeof saved === "boolean" ? saved : this.collapsedValue)
        this.showAll = false
        this.render()
    }

    toggle() {
        this.collapsed = !this.collapsed
        const saved = this.saved()
        saved[this.keyValue] = this.collapsed
        try {
            window.localStorage.setItem(STORE, JSON.stringify(saved))
        } catch (_error) {
            /* a private window still folds, it just forgets */
        }
        this.render()
    }

    more() {
        this.showAll = !this.showAll
        this.render()
    }

    render() {
        this.element.classList.toggle("is-collapsed", this.collapsed)
        this.bodyTarget.hidden = this.collapsed
        this.toggleTarget.setAttribute("aria-expanded", String(!this.collapsed))

        const rows = this.rowTargets
        const limit = this.limitValue
        const hidden = limit > 0 && !this.showAll ? Math.max(rows.length - limit, 0) : 0
        rows.forEach((row, index) => { row.hidden = limit > 0 && !this.showAll && index >= limit })
        if (!this.hasMoreTarget) return

        const extra = Math.max(rows.length - limit, 0)
        this.moreTarget.hidden = !(limit > 0 && extra > 0)
        this.moreTarget.textContent = hidden > 0 ? `Show ${hidden} more` : "Show less"
    }

    saved() {
        try {
            const saved = JSON.parse(window.localStorage.getItem(STORE) || "{}")
            return saved && typeof saved === "object" && !Array.isArray(saved) ? saved : {}
        } catch (_error) {
            return {}
        }
    }
}
